export default __webpack_public_path__ + "static/media/design-icon.e80210c2.png";